import { useEffect } from 'react';
import logoIcon from '../../assets/icons/MeinGruenraum_Logo.png';

const SplashScreen = ({ onDone }) => {
  useEffect(() => {
    const timer = setTimeout(onDone, 1500);
    return () => clearTimeout(timer);
  }, [onDone]);

  return (
    <div
      className="fixed inset-0 bg-white flex flex-col items-center"
      style={{ paddingTop: '30%' }}
    >
      <div className="flex flex-col items-center gap-5">
        <img
          src={logoIcon}
          alt="Mein Grünraum"
          className="w-20 h-20 object-contain"
        />
        <div className="flex flex-col items-center">
          <span className="text-base font-semibold text-gray-900">Mein Grünraum</span>
          <p className="text-[13px] text-gray-500 text-center max-w-[260px] mt-3 leading-relaxed">
            Dein Garten. Jahr für Jahr begleitet.
          </p>
        </div>
      </div>

      <div
        className="absolute bottom-8 left-0 right-0 text-center text-[11px] text-gray-500"
        style={{ fontFamily: 'monospace' }}
      >
        mein-gruenraum.de
      </div>
    </div>
  );
};

export default SplashScreen;
